import "../component/rem.js";
import "es6-promise/auto";
import Vue from "vue";
import store from "./store";
import App from "./App.vue";
import router from "./router";
// 解决IE浏览器上出现[vue-router] Failed to resolve async component default: ReferenceError: “Promise”未定义 这是由于es6语法解析不成功造成的
require('es6-promise').polyfill();
require('es6-promise/auto');
// 
// import 'babel-polyfill';
// import headerView from './components/header.vue';
import headerView from './com/header.vue';
Vue.component("headerView", headerView);
// import footView from "@/components/foot.vue"
import footView from "@/com/bottom.vue"
Vue.component("footView", footView);
import titleview from "./components/titleview.vue";
Vue.component("titleview", titleview);

//使用ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

//使用Antd
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);

import echarts from 'echarts'
import { httpGet, httpPost, httpPut, httpDelete, baseURL, localUrl, getFileAccessHttpUrl } from "./utils/request.js"
Vue.prototype.httpGet = httpGet;
Vue.prototype.httpPost = httpPost;
Vue.prototype.httpPut = httpPut;
Vue.prototype.httpDelete = httpDelete;
Vue.prototype.$baseURL = baseURL;
import {
    time,
    date,
    weeks,
    fendate,
    timeData
} from "./components/titme.js"
Vue.prototype.new_time = time;
Vue.prototype.new_timeData = timeData
Vue.prototype.new_date = date;
Vue.prototype.new_weeks = weeks;
Vue.prototype.new_fendate = fendate;


//用改变浏览器页签名称
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

//本地路径
Vue.prototype.$localUrl = localUrl;
Vue.prototype.getFileAccessHttpUrl = getFileAccessHttpUrl;

// 图片域名
Vue.prototype.imageUrl = localUrl;

// Vue.prototype.Swiper=Swiper;
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts
new Vue({
    router,
    store,
    echarts,
    render: h => h(App)
}).$mount("#app");
